import { getTitle } from "Pages/ServiceForm/helper";
import { Box } from "styles/globalComponents";

import { CATEGORIES } from "Constants/Categories";

import { useBudgetContext } from "Hooks/useBudgetContext";
import { useCart } from "Hooks/useCart";

import CartItem from "Components/ServiceForm/CartItem";

import ClincisIcon from "Assets/Images/clinics-icon.png";
import HomeIcon from "Assets/Images/home-icon.png";
import partnerIcon from "Assets/Images/partner-icon.png";

import { RefreshCw } from "lucide-react";
import { CartItem as ICartItem } from "Dtos/IBudget";
import { AttendmentTypeProps } from "./interface";
import { Container } from "./styles";

export const AttendmentItem = ({ attendment }: AttendmentTypeProps) => {
  const {
    budget,
    zipCode,
    setReplaceProductModal,
    setReplaceProductSelected,
    newTrackingModel,
  } = useBudgetContext();
  const { updateAmountCartButton } = useCart();

  const { is_covenant, unit } = budget ?? {};

  const { cartAttendments, type, budget_type } = attendment;

  const title = getTitle(type);

  const zipcode = zipCode.replace(/^(\d{5})(\d{3})$/, "$1-$2");

  const onReplaceProduct = (product: ICartItem) => {
    setReplaceProductModal(true);
    setReplaceProductSelected(product);
  };

  return (
    <Container>
      <section className="budget-collect-type">
        <article>
          {budget_type === CATEGORIES.image && (
            <div>
              <img src={partnerIcon} alt="" />
            </div>
          )}

          {budget_type !== CATEGORIES.image && (
            <>
              {type === "home_collect" && (
                <div>
                  <img src={HomeIcon} alt="" />
                </div>
              )}
              {type === "unity_collect" && (
                <div>
                  <img src={ClincisIcon} alt="" />
                </div>
              )}

              {type === "both" && (
                <Box display="flex">
                  <img src={HomeIcon} alt="" />
                  <img
                    src={ClincisIcon}
                    alt=""
                    style={{ marginLeft: "-1.5em" }}
                  />
                </Box>
              )}
            </>
          )}
        </article>
        <Box display="flex" direction="column" gap="0" align="flex-start">
          <p className="cart-home-or-unit-title">
            <strong>ATENDIMENTO</strong> <br />
            {budget_type === CATEGORIES.consult && "LABI CLÍNICA"}
            {budget_type === CATEGORIES.image && "PARCEIRO"}
            {budget_type !== CATEGORIES.consult &&
              budget_type !== CATEGORIES.image &&
              !is_covenant &&
              title.toUpperCase()}
          </p>

          {is_covenant && (
            <p className="color-purple">
              {" "}
              {zipCode
                ? `EM CASA - CEP ${zipcode} `
                : `NA UNIDADE ${unit ? unit?.name.toLocaleUpperCase() : ""}`}
            </p>
          )}
        </Box>
      </section>
      <div className="cart-itens-holder new-layout-cart-itens-holder">
        {cartAttendments.map((item) => (
          // @ts-ignore
          <CartItem
            key={item?.id}
            isProduct
            product={item}
            newLayout
            amountAction={updateAmountCartButton}
            debounceDep={newTrackingModel || budget}
          >
            {item.ai && (
              <Box display="flex" gap="3">
                <span className="ia-tag" title="Produto adicionado via IA">
                  [IA]
                </span>
                <button
                  className="replace-btn"
                  onClick={() => onReplaceProduct(item)}
                >
                  <RefreshCw size={15} />
                </button>
              </Box>
            )}
          </CartItem>
        ))}
      </div>
    </Container>
  );
};
